import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type CallCenterViewModel } from '@/features/call-center/CallCenterViewModel'
import { JobCheckoutContainer } from '@/features/call-center/JobCheckout/JobCheckoutContainer'

export default observer(function CallCenterCheckoutPageContainer() {
  const vm = useOutletContext<CallCenterViewModel>()

  return <JobCheckoutContainer jobVm={vm.jobVm} />
})
